import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import AgGrid from '../../shared/agGrid/agGrid.component';
import Numeral, { NumeralTypes } from '../../shared/numeral.component';
import { accountActivityColumnDefs } from '../../shared/columnDefinitions/accountActivity';

import { sizeColumnsToFit } from '@client-shared/ui-agGrid';

import { accountActivityPropType } from '../shared/propTypes';

class AccountActivityGrid extends PureComponent {
  static propTypes = {
    accountActivity: PropTypes.arrayOf(accountActivityPropType).isRequired,
    accountActivityLoading: PropTypes.bool.isRequired,
    chosenValuesText: PropTypes.string,
  };

  static defaultProps = {
    chosenValuesText: '',
  };

  onGridReady = params => {
    sizeColumnsToFit(params.api);
  };

  render() {
    const { accountActivity, accountActivityLoading, chosenValuesText } = this.props;

    const currentBalanceRow = accountActivity.find(balance => balance.description === 'Current Balance') || { amount: 0 };
    const accountActivityWithoutCurrentBalanceRow = accountActivity.filter(balance => balance.description !== 'Current Balance');

    return (
      <div className="ag-grid-full-page-with-secondary-menu">
        <div className="row no-gutters">
          <div className="col">
            <h5>Account Activity</h5>
          </div>
        </div>
        <div className="d-flex flex-row justify-content-between">
          <div>
            {chosenValuesText}
          </div>
          <div>
            Current Balance: <Numeral type={NumeralTypes.DECIMAL}>{currentBalanceRow.amount}</Numeral>*
          </div>
        </div>
        <AgGrid
          columnDefs={accountActivityColumnDefs}
          headerHeight={50}
          rowData={accountActivityWithoutCurrentBalanceRow}
          isGridLoading={accountActivityLoading}
          onGridReady={this.onGridReady}
        />
        <div className="row mt-2">
          <div className="col">
            <div className="float-right">
              *Subledger balances only include approved subledger tax entries.
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AccountActivityGrid;
